<template>
    <div v-if="registerFormView">
        <Nav></Nav>
        <PageHeader :linkto="'/login'" :linkttitle="'返回'" title=""></PageHeader>
        <b-container  class="bg-white p-3 p-md-5 mt-5 mt-sm-2 shadow-sm rounded ">

            <b-form  style="max-width: 400px" class="mx-auto">
                <h3 class="text-center mb-5">還差一點點，就準備好囉！</h3>
                <TipsAlert :tipswords="masterTips.tipswords"
                           :status="masterTips.status"
                           :videostatus="masterTips.videostatus"
                           :videosrc="masterTips.videosrc">

                </TipsAlert>
                <b-form-group label-for="phone" description="">
                    <label>姓名<span class="text-danger">* 請輸入真實姓名</span></label>
                    <b-input-group class="mb-2">
                        <b-form-input v-model="formData.firstname"
                                      type="text"
                                      required
                                      maxlength="2"
                                      @change="checkvalue('name')"
                                      placeholder="輸入姓氏"></b-form-input>
                        <b-form-input v-model="formData.lastname"
                                      type="text"
                                      required
                                      maxlength="2"
                                      @change="checkvalue('name')"
                                      placeholder="輸入姓名"></b-form-input>

                    </b-input-group>
                    <b-form-invalid-feedback :state="formData.namecheck">
                        {{ formData.namemsg }}
                    </b-form-invalid-feedback>
                </b-form-group>
                <hr>

                <b-form-group>
                    <label>性別<span class="text-danger">* </span></label>
                    <b-form-radio-group
                            v-model="selected"
                            :options="options"
                            name="radio-inline"
                            @input="checkvalue('male')"
                    ></b-form-radio-group>
                    <b-form-invalid-feedback :state="formData.malecheck">
                        {{ formData.malemsg }}
                    </b-form-invalid-feedback>
                </b-form-group>

                <hr>
                <b-row>
                    <b-col>
                        <b-form-group

                                label-for="phone"
                                description=""
                        >
                            <label>手機號碼綁定<span class="text-danger">*</span></label>

                            <b-form-input
                                    id="phone"
                                    v-model="formData.username"
                                    type="text"
                                    required
                                    maxlength="10"
                                    @change="checkvalue('username')"
                                    placeholder="輸入手機號碼"
                                    autocomplete
                            ></b-form-input>
                            <b-form-invalid-feedback :state="formData.usernamecheck">
                                {{ formData.usernamemsg }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group

                                label-for="phone"
                                description=""
                        >
                            <label>驗證碼<span class="text-danger">*</span></label>
                            <b-input-group>
                                <b-button v-if="smsbtn" variant="success" @click="sendSMS" ><b-spinner small type="grow" v-if="smsloading"></b-spinner>取得驗證碼</b-button>

                                <b-form-input
                                        v-else
                                        v-model="formData.verifcode"
                                        type="text"
                                        required
                                        maxlength="4"
                                        @change="checkvalue('verifcode')"
                                        placeholder="輸入簡訊驗證碼"
                                ></b-form-input>
                                <b-input-group-append>
                                    <b-button v-if="!smsbtn" variant="success" :disabled="!smsbtn"> {{countDown}}'s </b-button>
                                </b-input-group-append>

                            </b-input-group>
                            <b-form-invalid-feedback :state="formData.verifcodecheck">
                                {{ formData.verifcodemsg }}
                            </b-form-invalid-feedback>

                        </b-form-group>
                    </b-col>
                </b-row>

                <b-overlay
                        :show="registerloading"
                        rounded
                        opacity="0.6"
                        spinner-small
                        spinner-variant="primary"
                        class=" mt-3"

                >
                    <b-button class="mt-3" variant="primary ActionBtnBg" pill block @click="Register">完成登入</b-button>
                </b-overlay>


            </b-form>
            <p class="mt-3 mb-5 text-center text-muted">註冊並使用賬號表明您已閱讀和同意
                <b-link class="text-muted" href="#foo" target="_blank">《用戶協議》</b-link>
            </p>
        </b-container>


    </div>


</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import PageHeader from '@/components/PageHeader.vue'
import TipsAlert from '@/components/TipsAlert.vue'
import { toastsModel, isch } from '@/service/commuse'

export default {
  name: 'LineLogin',
  components: {Nav, PageHeader, TipsAlert},
  data () {
    return {
      registerFormView: false,

      masterTips: {
        status: true,
        videostatus: false,
        videosrc: '',
        tipswords: '為了測算與比對的精準，姓和名請務必要認真填寫您的真實姓名，打錯字就不準了唷，請按下註冊鍵時再三檢查資料是否正確。',
      },
      formData: {
        verifcode:'',
        verifcodecheck:null,
        verifcodemsg:'',
        username: '',
        usernamecheck: null,
        usernamemsg: '',
        access_token: '',
        id_token: '',
        firstname: '',
        lastname: '',
        namecheck: null,
        namemsg: '',
        email: '',
        emailcheck: null,
        emailmsg: '',
        male: 0,
        malecheck: null,
        malemsg: '',
      },
      selected: '',
      options: [
        {text: '男', value: '1'},
        {text: '女', value: '0'}
      ],

      registerloading: false,
      smsloading:false,
      countDown: 1800, //倒计时
      smsbtn:true

    }
  },
  mounted () {
    let getUrlString = location.href
    let url = new URL(getUrlString)
    this.getToken(url.searchParams.get('code'), url.searchParams.get('state'))
  },
  computed: {},
  methods: {
    getToken (code, state) {
      this.$store.dispatch('actionLineLogin', {
        code: code,
        state: state
      }).then((res) => {

        console.log(res)
        if (!res.data.register_status) {
          this.formData.access_token = res.data.access_token
          this.formData.id_token = res.data.id_token
          this.registerFormView = true



        }else{
          this.getMemberInfo();
        }

      }).catch((res) => {

        this.$router.push('/login');

      })
    },
    checkvalue (way) {
      switch (way) {
        case 'username':
          if (this.formData.username.length == 0 || this.formData.username.length < 10) {
            this.formData.usernamemsg = '請填寫行動電話號碼'
            this.formData.usernamecheck = false
          }
          let isPhone = /^09\d{8}$/
          if (!isPhone.test(this.formData.username)) {
            this.formData.usernamemsg = '請填寫正確行動電話號碼'
            this.formData.usernamecheck = false
          }
          else {
            this.formData.usernamemsg = ''
            this.formData.usernamecheck = true
          }
          break
        case 'verifcode':

          if (this.formData.verifcode.length === 0 || this.formData.verifcode.length < 4) {
            this.formData.verifcodemsg = '請輸入驗證碼'
            this.formData.verifcodecheck = false
          }
          break
        case 'name':

          if (this.formData.firstname.length === 0 || this.formData.lastname.length === 0) {
            this.formData.namemsg = '姓名很重要！別忘囉'
            this.formData.namecheck = false

          } else {
            this.formData.namemsg = ''
            if (!isch(this.formData.firstname)) {
              this.formData.namemsg = '請填寫中文姓名名字'
              this.formData.namecheck = false
            } else {
              this.formData.namemsg = ''
              this.formData.namecheck = true
            }
          }
          break

        case 'male':

          if (this.selected === '') {
            this.formData.malecheck = false
            this.formData.malemsg = '請選擇性別'
          } else {
            this.formData.malecheck = true
          }
          break
        case 'email':
          let emailRule = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/
          if (!emailRule.test(this.formData.email)) {
            this.formData.emailmsg = '請輸入您的信箱'
            this.formData.emailcheck = false
          } else {
            this.formData.emailcheck = true
          }
          break
        case 'namefinalcheck':

          if (this.selected === '') {
            this.formData.malecheck = false
            this.formData.malemsg = '請選擇性別'
          } else {
            this.formData.malecheck = true
          }
          break
      }

    },
    Register () {
      this.checkvalue('name')
      this.checkvalue('male')
      this.checkvalue('namefinalcheck')
      this.checkvalue('username')

      if (
        this.formData.namecheck == true &&
        this.formData.malecheck == true &&
        this.formData.usernamecheck == true
      ) {
        this.registerloading = true

        this.$store.dispatch('actionLineRegister', {
          username: this.formData.username,
          firstname: this.formData.firstname,
          lastname: this.formData.lastname,
          nametype: this.formData.firstname.length == 2 ? 1 : 0,
          male: this.formData.male,
          access_token: this.formData.access_token,
          id_token: this.formData.id_token,
          VerifCode:this.formData.verifcode
        }).then((res) => {

          this.getMemberInfo();

        }).catch((res) => {
          toastsModel(this, res.message)
          // this.registerloading = false
        })
      }

    },
    getMemberInfo(){
      this.$store.dispatch('actionGetMemberInfo', {})
        .then((res) => {
          this.$router.push('/home')
          this.registerloading = false
        })
        .catch((res) => {
          this.registerloading = false
        })
    },
    sendSMS(){

      this.checkvalue('username')
      if (this.formData.usernamecheck == true
      ) {

        this.smsloading=true
        this.$store.dispatch('actionSendVerifCode', {
          phone:this.formData.username
        })
          .then((res) => {
            this.smsbtn = false
            this.count(res.data.exp);
            this.formData.verifcodemsg = ''
            this.formData.verifcodecheck = true
            this.smsloading = false
          })
          .catch((res) => {
            this.formData.verifcodemsg = res.message
            this.formData.verifcodecheck = false
            this.smsloading = false
          })
      }
    },
    count(exp) {
      const dateTime = Date.now();
      const timestamp = Math.floor(dateTime);
      this.countDown = parseInt((exp*1000-timestamp)/1000);
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.countDown--;
        if (this.countDown == 0) {

          clearInterval(this.timer);

          this.smsbtn = true
        }
      }, 1000);
    },

  }
}
</script>
